// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_49-6";
export var headerCell = "_49-2";
export var rowWrapper = "_49-4";
export var stickyAggregationCell = "_49-a";
export var stickyAggregationRow = "_49-7";
export var stickyColumnCell = "_49-9";
export var stickyColumnHeaderCell = "_49-8";
export var table = "_49-1";
export var virtualRowWrapper = "_49-5";
export var virtualTableContainer = "_49-0";
export var white = "_49-3";